import React from 'react';
import { ReportCard } from './components/ReportCard/ReportCard';
import styles from './Report.module.scss';

const dashboardCards = [
  {
    name: 'receive',
  },
  {
    name: 'complete',
  },
  {
    name: 'annulled',
  },
  {
    name: 'period',
  },
];

export const Report = ({ onlyThisPeriod }) => {
  return (
    <div className={styles.root}>
      {dashboardCards.map((item) => (
        <ReportCard
          onlyThisPeriod={onlyThisPeriod}
          key={item.name}
          name={item.name}
        />
      ))}
    </div>
  );
};
